/**
 * Shared default pino-compatible level mapping for frontend and backend.
 *
 * Keep the gaps between values (10, 20, 30, ...) to leave space for future
 * custom levels (e.g. 9, 11, 21) without remapping core levels.
 */
export const DefaultLogLevels = {
    silent: Infinity,
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10,
};
//# sourceMappingURL=types.js.map